export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Bright%20airy%20seminar%20and%20training%20room%20interior%20with%20light%20wooden%20tables%20and%20simple%20chairs%20arranged%20for%20group%20learning%2C%20soft%20green%20potted%20plants%2C%20large%20windows%20with%20warm%20natural%20daylight%2C%20calm%20welcoming%20educational%20atmosphere%20for%20personal%20development%20workshops%2C%20realistic%20high%20quality%20editorial%20photography%2C%20warm%20cream%20and%20olive%20green%20color%20palette%2C%20no%20people%2C%20generous%20negative%20space&width=1800&height=1100&seq=hero-2026-02&orientation=landscape"
          alt="Heller, einladender Kursraum für Persönlichkeitsentwicklung"
          title="Stephanie Wolf Kursraum Persönlichkeitsentwicklung Kurskonzepte"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="mx-auto max-w-7xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 backdrop-blur border border-background-50/25 px-4 py-1.5 text-xs md:text-sm text-background-50">
            <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            Ganzheitliche Persönlichkeitsentwicklung
          </span>

          <h1 className="mt-6 text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-background-50 leading-tight max-w-4xl mx-auto">
            Menschen stärken.
            <br />
            Kompetenzen entwickeln.
            <br />
            <span className="text-accent-300">Zukunft gestalten.</span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-background-100/90 leading-relaxed max-w-2xl mx-auto">
            Kurskonzepte für soziale Kompetenz, Persönlichkeitsentwicklung und die
            Vorbereitung auf den Arbeitsmarkt – für Bildungseinrichtungen, Schulen,
            Werkstätten für Menschen mit Behinderung und alle, die Menschen auf ihrem
            Weg begleiten.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#konzepte"
              className="whitespace-nowrap rounded-full bg-accent-500 text-foreground-950 px-7 py-3 text-sm md:text-base font-semibold hover:bg-accent-400 transition-colors cursor-pointer"
            >
              Kurskonzepte entdecken
            </a>
            <a
              href="#kontakt"
              className="whitespace-nowrap rounded-full border border-background-50/40 text-background-50 px-7 py-3 text-sm md:text-base font-semibold hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              Angebot anfragen
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}